import { IconButton, styled } from "@mui/material";

export const CallButton = styled(IconButton)({
  backgroundColor: 'transparent',
  color: '#0675DD',
  border: '1px solid #0675DD'
});
